import { ConversionBlock } from '@/entities/conversion'
import { StatColumn } from '../StatColumn'

interface TodaysStatsSectionProps {
  currency: number
  dailyLimit: number
  dailyTopupsCounter?: number
  monthlyTopupsCounter?: number
  counterInSuccess?: number
  counterIn?: number
}

export const TodaysStatsSection = ({
  counterInSuccess,
  counterIn,
}: TodaysStatsSectionProps) => {
  return (
    <div className="flex flex-col gap-2 md:gap-4">
      <span className="text-base">Сегодня</span>
      <div className="flex flex-col md:flex-row md:gap-8">
        <StatColumn
          label="Конверсия"
          value={<ConversionBlock current={counterInSuccess ?? 0} goal={counterIn ?? 0} />}
        />
        <StatColumn label="Сделки" value={`${counterInSuccess ?? 0} / ${counterIn ?? 0}`} />
      </div>
    </div>
  )
}
